var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 10L12 15L17 10H7Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }